import { CursorArrowRaysIcon, PencilIcon } from '@heroicons/react/24/outline';
import { SpaceDrawMode } from 'utils/space-draw-mode';
import { GridModeToolbarItem } from './grid-mode-toolbar-item';

export const SPACE_DRAW_MODE_TOOLBAR_ITEMS: GridModeToolbarItem<SpaceDrawMode>[] =
  [
    {
      id: 'select',
      icon: CursorArrowRaysIcon,
      label: 'Select & Move',
      shortcutKey: 'S'
    },
    { id: 'draw', icon: PencilIcon, label: 'Draw Space', shortcutKey: 'D' }
  ];

export function isSpaceDrawModeDisabled(
  mode: SpaceDrawMode,
  isNewSpaceBlocked: boolean
): boolean {
  return mode === 'draw' && isNewSpaceBlocked;
}
